import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Block.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Block extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            name: {},
            type: {},
            payload: {},
            event: {}
        };
    }

    static listUrl({ organizationId, siteId }) {
        if (!organizationId || !siteId) {
            throw new ArgumentError('[Model][Block] organizationId and siteId are mandatory');
        }
        return `/sites/organizations/${organizationId}/sites/${siteId}/blocks`;
    }
}
